import { SvgIconProps } from '@/types/helpers'

export default function CircleCheck(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      {...props}>
      <g clipPath="url(#clip0_650_64389)">
        <path
          d="M12 24.4922C5.47266 24.4922 0.046875 19.0664 0.046875 12.5391C0.046875 6 5.46094 0.585938 11.9883 0.585938C18.5273 0.585938 23.9531 6 23.9531 12.5391C23.9531 19.0664 18.5391 24.4922 12 24.4922ZM10.6875 18.2695C11.0859 18.2695 11.4258 18.082 11.6719 17.6953L17.1797 9.02344C17.3203 8.77734 17.4727 8.50781 17.4727 8.25C17.4727 7.69922 16.9922 7.34766 16.4766 7.34766C16.1719 7.34766 15.8672 7.53516 15.6445 7.88672L10.6406 15.9258L8.26172 12.8555C7.96875 12.4688 7.71094 12.3633 7.37109 12.3633C6.84375 12.3633 6.43359 12.7969 6.43359 13.3242C6.43359 13.5938 6.53906 13.8516 6.71484 14.0859L9.65625 17.6953C9.96094 18.1055 10.2891 18.2695 10.6875 18.2695Z"
          fill="currentFill"
        />
      </g>
      <defs>
        <clipPath id="clip0_650_64389">
          <rect width="24" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
